import { snapshot } from 'valtio';
import { isValidEmail } from '../../common/common-utils';
import InviteMemberStore from '../stores/invite-user-store';
import MembersStore from '../stores/members-store';
import { Role } from '../types/members-types';

export const closeInviteUserModal = (): void => {
  InviteMemberStore.hasErrorMessage = false;
  InviteMemberStore.errorMessage = '';
  setModalVisibility(false);
};

export const openInviteUserModal = (): void => {
  setModalVisibility(true);
};

const setModalVisibility = (payload: boolean): void => {
  InviteMemberStore.isModalVisible = payload;
};

export const setInviteButtonEnabled = (
  email: string,
  selectedRoles: Role[],
): void => {
  if (email.length < 6) {
    InviteMemberStore.isInviteButtonEnabled = false;
    return;
  }

  if (!isValidEmail(email)) {
    InviteMemberStore.isInviteButtonEnabled = false;
    InviteMemberStore.hasErrorMessage = true;
    InviteMemberStore.errorMessage = 'Invalid Email address';
    return;
  }

  if (isAlreadyInvited(email)) {
    InviteMemberStore.hasErrorMessage = true;
    InviteMemberStore.errorMessage = 'User already has a pending invitation';
    return;
  }

  if (isAlreadyAMember(email)) {
    InviteMemberStore.hasErrorMessage = true;
    InviteMemberStore.errorMessage = 'User is already a member';
    return;
  }

  InviteMemberStore.hasErrorMessage = false;
  InviteMemberStore.errorMessage = '';

  if (selectedRoles.length === 0) {
    InviteMemberStore.isInviteButtonEnabled = false;
    return;
  }

  InviteMemberStore.isInviteButtonEnabled = true;
};

const isAlreadyInvited = (email: string) => {
  const { pendingInvitationMembers } = snapshot(InviteMemberStore);
  return pendingInvitationMembers.some(p => p.inviteeEmail === email);
};

const isAlreadyAMember = (email: string) => {
  const { activeMembers } = snapshot(MembersStore);
  return activeMembers.some(a => a.email === email);
};

export const checkIsInvitationExpired = (invitationExpiration: string) => {
  const dateNowISOString = new Date().toISOString();
  return dateNowISOString > invitationExpiration;
};

export const getInvitationExpirationLocalTime = (
  invitationExpiration: string,
) => {
  return new Date(invitationExpiration).toLocaleString();
};
